import React from 'react'
import {BsArrowUpShort} from 'react-icons/bs'
import './scroll.css'

const Scroll = () => {
  return (
    <div className='scroll__container'>
        <a href="#"><BsArrowUpShort className='scroll__arrow'/></a>
    </div>
  )
}

export default Scroll